import type { AppLocale } from '@/constants/appLocale';
import { isAppLocale } from '@/constants/appLocale';
import * as enUS from './en_US';
import * as jaJP from './ja_JP';
import * as koKR from './ko_KR';
import * as zhCN from './zh_CN';
import * as zhTW from './zh_TW';

const byLocale: Record<AppLocale, { title: string; body: string }> = {
  ja_JP: { title: jaJP.termsTitle, body: jaJP.termsBody },
  zh_CN: { title: zhCN.termsTitle, body: zhCN.termsBody },
  zh_TW: { title: zhTW.termsTitle, body: zhTW.termsBody },
  en_US: { title: enUS.termsTitle, body: enUS.termsBody },
  ko_KR: { title: koKR.termsTitle, body: koKR.termsBody },
};

/** 按 i18n.language（与 APP_LOCALES 一致）解析条款文案 */
export function getTermsContent(language: string) {
  if (isAppLocale(language)) return byLocale[language];
  return byLocale.ja_JP;
}
